import { ChartMode } from "src/components/ScoreDetail/Chart/chart.types";
import { ModalData } from "src/components/ScoreDetail/PropertyModal/PropertyModal";
import { UserProperty } from "src/context/Property/Builder/PropertyBuilder";
import { DrilldownState } from "src/context/ScoreDetail/useDrilldown";

type Options = {
    property: UserProperty<unknown>;
    mode: ChartMode;
    openModal: (property: ModalData) => void;
    drilldown: (item: DrilldownState) => void;
};

type PropertyCallback = (() => void) | undefined;

export const propertyActionRuleset = (options: Options): PropertyCallback => {
    const { property, mode, openModal, drilldown } = options;

    const isValue = property.type === "value";
    const openModalHandler = () => {
        openModal(property);
    };
    const propertyDrilldown = () => {
        drilldown({
            id: property.property.id,
            label: property.name,
            type: "properties",
        });
    };

    switch (mode) {
        case "distribution":
            if (isValue) {
                return openModalHandler;
            }
            return propertyDrilldown;
        case "comparison":
            if (isValue) {
                return;
            }
            return propertyDrilldown;
        case "evolution":
            return;
        default:
            /* eslint-disable-next-line no-case-declarations */
            const _d: never = mode;
    }
};
